<template>
  <el-dialog
    title=""
    custom-class="custom-login-dialog"
    :show-close="false"
    :modal-append-to-body="false"
    :top="top"
    :modal="true"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="330px">
    <img v-if="dialogVisible" class="close-icon" @click="dialogVisible = false" src="@/assets/img/close.png" />
    <LoginBox v-if="dialogVisible" />
  </el-dialog>
</template>
<script>
import LoginBox from './LoginBox'
export default {
  name: 'LoginModal',
  data() {
    return {
      dialogVisible: false,
      top: 'calc(50vh - 214px)'
    }
  },
  components: {
    LoginBox
  },
  mounted() {
    this.$bus.$on('changeLoginModal', (bool) => {
      this.dialogVisible = bool
    })
  }
}
</script>
<style lang="scss">
  .custom-login-dialog {
    background: transparent;
    border-radius: 6px;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .close-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: 24px;
    user-select: none;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/LoginModal.vue